import { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_session-manager-61/artifacts/oiyq9sc2_Dynamo%20Logo%5B4147%5D.png";

export default function PlaceAccept() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");
  const [info, setInfo] = useState(null);
  const [errMsg, setErrMsg] = useState("");
  const called = useRef(false);

  useEffect(() => {
    if (!token) { setState("error"); setErrMsg("No token found in this link."); return; }
    if (called.current) return;
    called.current = true;
    axios.post(`${API}/place/accept`, { token })
      .then(({ data }) => { setInfo(data); setState(data.already_processed ? "already" : "confirmed"); })
      .catch(err => { setState("error"); setErrMsg(err.response?.data?.detail || "Something went wrong."); });
  }, [token]); // eslint-disable-line

  return (
    <div style={{ fontFamily: "Arial, sans-serif", minHeight: "100vh", backgroundColor: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div style={{ backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.08)", padding: "48px 40px", maxWidth: "480px", width: "100%", textAlign: "center" }}>
        <img src={LOGO} alt="Dynamo Gymnastics" style={{ width: "120px", marginBottom: "32px" }} />

        {state === "loading" && (
          <>
            <Loader size={48} style={{ color: "#1656a4", animation: "spin 1s linear infinite", marginBottom: "16px" }} />
            <p style={{ color: "#64748b", fontSize: "15px" }}>Confirming your place…</p>
          </>
        )}

        {(state === "confirmed" || state === "already") && info && (
          <>
            <CheckCircle size={56} style={{ color: "#16a34a", marginBottom: "16px" }} />
            <h1 style={{ fontSize: "22px", fontWeight: "bold", color: "#111827", margin: "0 0 8px" }}>
              {state === "already" ? "Place Already Confirmed!" : "Place Confirmed!"}
            </h1>
            <p style={{ color: "#374151", fontSize: "15px", lineHeight: "1.6", margin: "0 0 24px" }}>
              Fantastic — <strong>{info.child_first_name}</strong>'s permanent place has been confirmed in:
            </p>
            <div style={{ backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "10px", padding: "20px", marginBottom: "24px" }}>
              <p style={{ margin: "0 0 4px", fontSize: "16px", fontWeight: "bold", color: "#15803d" }}>
                {info.class_days || info.class_day}
              </p>
              <p style={{ margin: "0 0 4px", fontSize: "18px", color: "#111827", fontWeight: "bold" }}>
                {info.class_start_time}{info.class_end_time ? `–${info.class_end_time}` : ""}
              </p>
              {info.class_category && (
                <p style={{ margin: "0", fontSize: "14px", color: "#6b7280" }}>{info.class_category}</p>
              )}
            </div>
            <p style={{ color: "#6b7280", fontSize: "13px", lineHeight: "1.6" }}>
              We'll be in touch shortly to set you up on Thrive4 so you can complete your details and set up your Direct Debit.
            </p>
          </>
        )}

        {state === "error" && (
          <>
            <XCircle size={56} style={{ color: "#dc2626", marginBottom: "16px" }} />
            <h1 style={{ fontSize: "20px", fontWeight: "bold", color: "#111827", margin: "0 0 8px" }}>Something went wrong</h1>
            <p style={{ color: "#6b7280", fontSize: "14px", lineHeight: "1.6" }}>{errMsg}</p>
            <p style={{ color: "#6b7280", fontSize: "13px", marginTop: "16px" }}>
              Please contact us on <strong>02380 455007</strong> or email{" "}
              <a href="mailto:admin@dynamogymnastics.co.uk" style={{ color: "#1656a4" }}>admin@dynamogymnastics.co.uk</a>
            </p>
          </>
        )}

        <p style={{ marginTop: "40px", fontSize: "11px", color: "#9ca3af", borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
          Dynamo Gymnastics · Hamble Sports Complex · Satchell Lane, SO31 4NE
        </p>
      </div>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
